import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['removeUserLink']

  readonly removeUserLinkTargets!: HTMLElement[]
  readonly hasRemoveUserLinkTarget!: boolean

  removeUser(event: Event): void {
    event.preventDefault()
    const link = event.currentTarget as HTMLElement
    const container = link.closest('[data-behaviour~="remove-user"]')

    if (container instanceof HTMLElement) {
      container.style.display = 'none'
    }

    window.Silverfin.Spinner.start()
  }
}
